/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AchievementIcon = /*#__PURE__*/ createSvgIcon(
  'AchievementIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} stroke="currentColor">
            <path d="M6.181 1v5.308" strokeLinecap="round" />
            <path
              d="M6.17 6.03l5.17 9.252H1L6.17 6.03z"
              strokeLinejoin="round"
            />
            <path
              d="M11.884 8.751l3.265 6.53h-6.53l3.265-6.53z"
              strokeLinejoin="round"
            />
            <path
              d="M6.248 1.531h6.369l-1.592 1.593 1.592 1.592H7.575"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} stroke="currentColor">
            <path d="M7.474.822v6.822" strokeLinecap="round" />
            <path
              d="M7.459 7.288l6.645 11.89H.814l6.645-11.89z"
              strokeLinejoin="round"
            />
            <path
              d="M14.803 10.785L19 19.178h-8.393l4.196-8.393z"
              strokeLinejoin="round"
            />
            <path
              d="M7.56 1.505h8.186L13.699 3.55l2.047 2.047H9.265"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} stroke="currentColor">
            <path d="M8.915.784v8.337" strokeLinecap="round" />
            <path
              d="M8.897 8.685l8.12 14.531H.777l8.12-14.53z"
              strokeLinejoin="round"
            />
            <path
              d="M17.872 12.96L23 23.215H12.743l5.129-10.257z"
              strokeLinejoin="round"
            />
            <path
              d="M9.02 1.619h10.003l-2.5 2.5 2.5 2.502h-7.92"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default AchievementIcon;
